import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceHappy16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFaceHappy16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-9.275-.7a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m5.425-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0M4.82 9.534a.5.5 0 0 1 .646.281l.002.005.016.035q.024.053.083.15c.08.13.21.308.4.487.374.35 1.004.722 2.034.722s1.66-.373 2.034-.722a2.4 2.4 0 0 0 .483-.637l.016-.035.002-.005a.5.5 0 0 1 .931.366l-.466-.18.466.18v.001l-.001.002-.001.003-.004.008-.01.023q-.012.03-.034.074-.043.092-.13.238a3.4 3.4 0 0 1-.57.692c-.543.508-1.412.992-2.716.992s-2.173-.484-2.716-.992a3.4 3.4 0 0 1-.57-.692 3 3 0 0 1-.165-.312l-.01-.023-.003-.008-.001-.003v-.002L5 10l-.466.181a.5.5 0 0 1 .285-.647"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceHappy16);
